module.exports = __webpack_public_path__ + "_assets/img/service-a.3790b3ac.svg";